
import api from "./API";

export const PaymentService = {
  getClientSecret: async (params) => {
    return await api.post(`/get-payment-secret`, { ...params })
  }
}